/**
 * Feature route registry — the single wiring point between feature modules
 * and the app shell. A feature is any directory `src/features/<name>/` that
 * exports a `routes.tsx` module with a named `routes: RouteObject[]` export;
 * nothing else in the shell ever needs to change to add one.
 */

import type { RouteObject } from 'react-router-dom';

export interface FeatureRoutesModule {
  routes: RouteObject[];
}

const featureModules = import.meta.glob<{ routes: RouteObject[] }>('./*/routes.tsx', {
  eager: true,
});

/**
 * Flat list of every feature's routes, ordered by feature directory name for
 * deterministic matching. Consumed by `src/App.tsx` through `useRoutes`.
 * An empty registry (no feature `routes.tsx` modules yet) yields `[]` and the
 * app still builds and boots.
 */
export const featureRoutes: RouteObject[] = Object.entries(featureModules)
  .sort(([a], [b]) => a.localeCompare(b))
  .flatMap(([, mod]) => (Array.isArray(mod.routes) ? mod.routes : []));
